import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { passwordStrength, STRENGTH_LABELS } from 'helpers/passwordPolicy';

const BAR_COLORS = [
  'tw-bg-slate-200',
  'tw-bg-red-500',
  'tw-bg-orange-400',
  'tw-bg-amber-400',
  'tw-bg-green-500'
];

const TEXT_COLORS = [
  'tw-text-slate-400',
  'tw-text-red-600',
  'tw-text-orange-600',
  'tw-text-amber-600',
  'tw-text-green-600'
];

/**
 * A four-segment strength bar. Advisory only — PasswordPolicy decides what is
 * actually accepted, on the server and again in the form's own validation.
 */
const PasswordStrengthMeter = ({ password = '', className = '' }) => {
  const score = passwordStrength(password);

  return (
    <div className={classNames('tw-mt-1.5', className)}>
      <div className="tw-flex tw-gap-1" aria-hidden="true">
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className={classNames(
              'tw-h-1 tw-flex-1 tw-rounded-full tw-transition-colors',
              segment <= score ? BAR_COLORS[score] : 'tw-bg-slate-200'
            )}
          />
        ))}
      </div>
      <p className={classNames('tw-text-xs tw-mt-1 tw-mb-0', TEXT_COLORS[score])}>
        {password ? STRENGTH_LABELS[score] : 'Use at least 10 characters'}
      </p>
    </div>
  );
};

PasswordStrengthMeter.propTypes = {
  password: PropTypes.string,
  className: PropTypes.string
};

export default PasswordStrengthMeter;
